import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
const visualItems = ['Step-by-step movement sequences', 'Partner positioning', 'Footwork pathways', 'Directional arrows', 'Turn pathways', 'Hand positions', 'Weight-transfer diagrams', 'Correct-vs-incorrect comparisons', 'Beginner-to-advanced progressions', 'Combination maps', 'Troubleshooting systems', 'Instructor observation tools', 'Ready-to-teach class structures'];
export function WhyDifferent() {
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-358" data-mp="d3x4ehle7ei4">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-359" data-mp="d58baqa4x2dg">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-360" data-mp="i0nmfagrck66">
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-burgundy" data-id="element-361" data-mp="32q367lhk78mb">
            <EyeIcon size={16} strokeWidth={1.5} className="text-gold" aria-hidden="true" data-id="element-362" data-mp="3gowd7odmdtvp" />
            100% visual core teaching material
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-363" data-mp="3uq8qtt5b5jef">
            One of the biggest differences between Salsa & Bachata Instructor
            Ready and <span className="italic text-burgundy" data-id="element-364" data-mp="7iwlcr05331v">traditional dance manuals.</span>
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-365" data-mp="3j5w4rq9guzg" />
          <p className="mt-5 text-base leading-7 text-ink-muted" data-id="element-366" data-mp="3gjs322kwxlz">
            The six-volume core system is designed to help you see the
            information, not fight through pages of unnecessary text.
          </p>
          <FlowLine className="mt-6" steps={['See the movement', 'Understand the progression', 'Teach with confidence']} data-id="element-367" data-mp="r7p6dcsvfhu6" />
          <p className="mt-6 font-display text-xl font-medium italic leading-8 text-ink" data-id="element-368" data-mp="tcke5olwvjj9">
            See the movement. Understand the progression. Teach with
            confidence.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-gold/30 bg-white p-6 shadow-soft sm:p-9" data-id="element-369" data-mp="1396xg8yla2j6">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-burgundy" data-id="element-370" data-mp="1gztnlcqaak3n">
            Throughout the system you will find:
          </p>
          <ul className="mt-6 grid gap-x-6 sm:grid-cols-2" data-id="element-371" data-mp="1r0cdop8fywu0">
            {visualItems.map(item => <li key={item} className="flex items-center gap-2.5 border-b border-gold/20 py-3 text-sm font-medium text-ink" data-id="element-372" data-mp="3nsw3xijdz7ob">
                <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" data-id="element-373" data-mp="3l7odma8b38aq" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}